/* eslint-disable @typescript-eslint/naming-convention */
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { Environment, DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import {
    DashboardNavigationGroups,
    FeatureFlags,
    RouteParams
} from '@lsq-frontend/fasttrack-shared/app-constants';
import { AppRoutesI18n } from './app-routes.i18n';
import { CustomersRoutesI18n } from './customers.routes.i18n';
import { InvoiceRoutesI18n } from './invoice.routes.i18n';
import { ReportsRoutesI18n } from './reports-routes.i18n';
import { SettingsRoutesI18n } from './settings-routes.i18n';
import { InsightsRoutesI18n } from './insights.routes.i18n';

// Common/boilerplate.
export const BROWSER_NOT_SUPPORTED = 'BROWSER_NOT_SUPPORTED';
export const FACTORING = 'FACTORING';
export const FACTORING_HOME = 'FACTORING_HOME';
export const HEALTH = 'HEALTH';
export const HEALTH_ALT = 'HEALTH_ALT';
export const LOCAL = 'LOCAL';
export const LOCAL_BACKEND = 'LOCAL_BACKEND';
export const LOCAL_CLAIMS = 'LOCAL_CLAIMS';
export const LOCAL_USER_STATE = 'LOCAL_USER_STATE';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const NOT_FOUND = 'NOT_FOUND';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const ROOT = 'ROOT';
export const SELECT_ACCOUNT = 'SELECT_ACCOUNT';

// App routes.
export const CONTACT_US = 'CONTACT_US';
export const INCREASE_CREDIT_LIMIT = 'INCREASE_CREDIT_LIMIT';
export const INVOICE_UPLOAD_HISTORY = 'INVOICE_UPLOAD_HISTORY';
export const MOBILE_UPLOAD_TOKEN = 'MOBILE_UPLOAD_TOKEN';
export const MOBILE_UPLOADS = 'MOBILE_UPLOADS';
export const REQUEST_FUNDS = 'REQUEST_FUNDS';

// Child modules.
export const AR_APPLICATION = 'AR_APPLICATION';
export const AR_APPLICATION_APPLY = 'AR_APPLICATION_APPLY';
export const CLIENT_MANAGEMENT = 'CLIENT_MANAGEMENT';
export const CUSTOMER = 'CUSTOMER';
export const CUSTOMER_AGING = 'CUSTOMER_AGING';
export const CUSTOMER_COLLECTIONS = 'CUSTOMER_COLLECTIONS';
export const CUSTOMER_INELIGIBLES = 'CUSTOMER_INELIGIBLES';
export const CUSTOMER_OVERVIEW = 'CUSTOMER_OVERVIEW';
export const CUSTOMER_REPORTS = 'CUSTOMER_REPORTS';
export const CUSTOMER_PURCHASES = 'CUSTOMER_PURCHASES';
export const CUSTOMERS = 'CUSTOMERS';
export const CUSTOMERS_REQUEST_CREDIT = 'CUSTOMERS_REQUEST_CREDIT';
export const ENROLLMENT = 'ENROLLMENT';
export const FORM_DETAIL = 'FORM_DETAIL';
export const SUPPLY_CHAIN_DIRECT = 'SUPPLY_CHAIN_DIRECT';
export const SUPPLY_CHAIN_DIRECT_ACCOUNT = 'SUPPLY_CHAIN_DIRECT_ACCOUNT';
export const SUPPLY_CHAIN_DIRECT_ACCOUNT_OVERVIEW = 'SUPPLY_CHAIN_DIRECT_ACCOUNT_OVERVIEW';
export const SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICES = 'SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICES';
export const BUYER_ACCOUNT_INVOICE_DETAIL = 'BUYER_ACCOUNT_INVOICE_DETAIL';
export const SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIERS = 'SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIERS';
export const SUPPLY_CHAIN_DIRECT_ACCOUNT_PAYMENTS = 'SUPPLY_CHAIN_DIRECT_ACCOUNT_PAYMENTS';
export const SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIER_DETAILS =
    'SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIER_DETAILS';
export const ACCOUNT_SUPPLIER_DETAILS = 'ACCOUNT_SUPPLIER_DETAILS';
export const SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE =
    'SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE';
export const SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE_DETAIL =
    'SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE_DETAIL';
export const SUPPLY_CHAIN_DIRECT_BUYER = 'SUPPLY_CHAIN_DIRECT_BUYER';
export const SUPPLY_CHAIN_DIRECT_BUYER_OVERVIEW = 'SUPPLY_CHAIN_DIRECT_BUYER_OVERVIEW';
export const SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIERS = 'SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIERS';
export const SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIER_DETAILS =
    'SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIER_DETAILS';
export const BUYER_SUPPLIER_DETAILS = 'BUYER_SUPPLIER_DETAILS';
export const SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE =
    'SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE';
export const SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE_DETAIL =
    'SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE_DETAIL';
export const SUPPLY_CHAIN_DIRECT_BUYER_PAY_LATER = 'SUPPLY_CHAIN_DIRECT_BUYER_PAY_LATER';
export const SUPPLY_CHAIN_DIRECT_BUYER_INVOICES = 'SUPPLY_CHAIN_DIRECT_BUYER_INVOICES';
export const SUPPLY_CHAIN_DIRECT_BUYER_PAYMENTS = 'SUPPLY_CHAIN_DIRECT_BUYER_PAYMENTS';

export const SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_DETAILS =
    'SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_DETAILS';
export const EARLY_PAYMENT_DETAILS = 'EARLY_PAYMENT_DETAILS';
export const ACCOUNT_EARLY_PAYMENT_DETAILS = 'ACCOUNT_EARLY_PAYMENT_DETAILS';

export const SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_REMITTANCE_DETAILS =
    'SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_REMITTANCE_DETAILS';
export const EARLY_PAYMENT_REMITTANCE_DETAILS = 'EARLY_PAYMENT_REMITTANCE_DETAILS';
export const ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS = 'ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS';

export const SUPPLY_CHAIN_DIRECT_BUYER_INVOICE_TERMS_PAYMENT_DETAILS =
    'SUPPLY_CHAIN_DIRECT_BUYER_INVOICE_TERMS_PAYMENT_DETAILS';
export const INVOICE_TERMS_PAYMENT_DETAILS = 'INVOICE_TERMS_PAYMENT_DETAILS';
export const ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS = 'ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS';

export const SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS = 'SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS';
export const SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_WORKING_CAPITAL_LIFT =
    'SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_WORKING_CAPITAL_LIFT';
export const SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SPEND_VOLUME =
    'SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SPEND_VOLUME';
export const SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_DAYS_PAYABLE_OUTSTANDING =
    'SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_DAYS_PAYABLE_OUTSTANDING';
export const SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_EARLY_PAY_ADOPTION =
    'SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_EARLY_PAY_ADOPTION';
export const SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SUPPLIER_ENROLLMENT =
    'SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SUPPLIER_ENROLLMENT';
export const SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_AGING_FORECAST =
    'SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_AGING_FORECAST';
export const SUPPLY_CHAIN_DIRECT_SELLER = 'SUPPLY_CHAIN_DIRECT_SELLER';
export const SUPPLY_CHAIN_DIRECT_SELLER_PAYMENTS = 'SUPPLY_CHAIN_DIRECT_SELLER_PAYMENTS';
export const SUPPLY_CHAIN_DIRECT_SELLER_CONTACT_US = 'SUPPLY_CHAIN_DIRECT_SELLER_CONTACT_US';
export const SUPPLY_CHAIN_DIRECT_SELLER_INVOICES = 'SUPPLY_CHAIN_DIRECT_SELLER_INVOICES';
export const SUPPLY_CHAIN_DIRECT_SELLER_REPORTS = 'SUPPLY_CHAIN_DIRECT_SELLER_REPORTS';
export const SUPPLY_CHAIN_DIRECT_SELLER_REQUEST_EARLY_PAYMENT =
    'SUPPLY_CHAIN_DIRECT_SELLER_REQUEST_EARLY_PAYMENT';
export const SUPPLY_CHAIN_DIRECT_SELLER_CREATE_NEW_REPORT =
    'SUPPLY_CHAIN_DIRECT_SELLER_CREATE_NEW_REPORT';
export const SUPPLY_CHAIN_DIRECT_SELLER_EDIT_REPORT_ID =
    'SUPPLY_CHAIN_DIRECT_SELLER_EDIT_REPORT_ID';
export const SUPPLY_CHAIN_DIRECT_SELLER_REPORT_PREVIEW =
    'SUPPLY_CHAIN_DIRECT_SELLER_REPORT_PREVIEW';
export const SUPPLY_CHAIN_DIRECT_DASHBOARD = 'SUPPLY_CHAIN_DIRECT_DASHBOARD';
export const GROUPED_INVOICE_DETAIL = 'GROUPED_INVOICE_DETAIL';
export const SUPPLY_CHAIN_DIRECT_SELLER_PAYMENT = 'SUPPLY_CHAIN_DIRECT_SELLER_PAYMENT';
export const SUPPLY_CHAIN_DIRECT_SELLER_PAYMENT_SUMMARY =
    'SUPPLY_CHAIN_DIRECT_SELLER_PAYMENT_SUMMARY';
export const SUPPLY_CHAIN_DIRECT_SELLER_BUYER_PAYMENT_SUMMARY =
    'SUPPLY_CHAIN_DIRECT_SELLER_BUYER_PAYMENT_SUMMARY';
export const INVOICE_DETAIL = 'INVOICE_DETAIL';
export const SUPPLY_CHAIN_DIRECT_SELLER_PARENT_GROUPED_INVOICE =
    'SUPPLY_CHAIN_DIRECT_SELLER_PARENT_GROUPED_INVOICE';
export const SUPPLY_CHAIN_DIRECT_SELLER_PARENT_GROUPED_INVOICE_DETAIL =
    'SUPPLY_CHAIN_DIRECT_SELLER_PARENT_GROUPED_INVOICE_DETAIL';
export const SUPPLY_CHAIN_DIRECT_SELLER_BUYERS = 'SUPPLY_CHAIN_DIRECT_SELLER_BUYERS';
export const SUPPLY_CHAIN_PLATFORM = 'SUPPLY_CHAIN_PLATFORM';
export const SUPPLY_CHAIN_PLATFORM_SETTINGS = 'SUPPLY_CHAIN_PLATFORM_SETTINGS';
export const SUPPLY_CHAIN_PLATFORM_LANDING = 'SUPPLY_CHAIN_PLATFORM_LANDING';
export const SUPPLY_CHAIN_PLATFORM_NOT_AUTHORIZED = 'SUPPLY_CHAIN_PLATFORM_NOT_AUTHORIZED';
export const SUPPLY_CHAIN_PLATFORM_SESSION_TIMEOUT = 'SUPPLY_CHAIN_PLATFORM_SESSION_TIMEOUT';
export const SUPPLY_CHAIN_PLATFORM_ENROLLMENT_OVERVIEW =
    'SUPPLY_CHAIN_PLATFORM_ENROLLMENT_OVERVIEW';
export const SUPPLY_CHAIN_PLATFORM_ENROLLMENT_ENROLL = 'SUPPLY_CHAIN_PLATFORM_ENROLLMENT_ENROLL';
export const SUPPLY_CHAIN_PLATFORM_ENROLLMENT_NEXT_STEPS =
    'SUPPLY_CHAIN_PLATFORM_ENROLLMENT_NEXT_STEPS';
export const SUPPLY_CHAIN_PLATFORM_ENROLLMENT_NOT_INTERESTED =
    'SUPPLY_CHAIN_PLATFORM_ENROLLMENT_NOT_INTERESTED';
export const INVOICES = 'INVOICES';
export const INVOICES_INVOICE = 'INVOICES_INVOICE';
export const INVOICES_UPLOAD = 'INVOICES_UPLOAD';
export const REPORTS = 'REPORTS';
export const REPORTS_ACCOUNT_OVERVIEW = 'REPORTS_ACCOUNT_OVERVIEW';
export const REPORTS_AGING = 'REPORTS_AGING';
export const REPORTS_AVAILABLE_FUNDS_SUMMARY = 'REPORTS_AVAILABLE_FUNDS_SUMMARY';
export const REPORTS_CHECK_NUMBER_RESULTS = 'REPORTS_CHECK_NUMBER_RESULTS';
export const REPORTS_COLLECTIONS = 'REPORTS_COLLECTIONS';
export const REPORTS_CREDIT_REQUEST_HISTORY = 'REPORTS_CREDIT_REQUEST_HISTORY';
export const REPORTS_FUNDINGS = 'REPORTS_FUNDINGS';
export const REPORTS_INELIGIBLES = 'REPORTS_INELIGIBLES';
export const REPORTS_INVOICE_NUMBER_RESULTS = 'REPORTS_INVOICE_NUMBER_RESULTS';
export const REPORTS_PURCHASES = 'REPORTS_PURCHASES';
export const INSIGHTS = 'INSIGHTS';
export const INSIGHTS_OVERVIEW = 'INSIGHTS_OVERVIEW';
export const INSIGHTS_CUSTOMERS_BY_EXPOSURE = 'INSIGHTS_CUSTOMERS_BY_EXPOSURE';
export const SETTINGS = 'SETTINGS';
export const SETTINGS_SCF_DIRECT_BANK_ACCOUNTS = 'SETTINGS_SCF_DIRECT_BANK_ACCOUNTS';
export const SETTINGS_SCF_PLATFORM_PAYMENT_METHODS = 'SETTINGS_SCF_PLATFORM_PAYMENT_METHODS';
export const SETTINGS_SCF_PLATFORM_FAQ = 'SETTINGS_SCF_PLATFORM_FAQ';
export const SETTINGS_SCF_PLATFORM_NOTIFICATION_PREFERENCES =
    'SETTINGS_SCF_PLATFORM_NOTIFICATION_PREFERENCES';
export const SETTINGS_SCF_PLATFORM_MOBILE_MENU = 'SETTINGS_SCF_PLATFORM_MOBILE_MENU';
export const SETTINGS_MANAGE_USERS = 'SETTINGS_MANAGE_USERS';
export const SETTINGS_SCF_MANAGE_USERS = 'SETTINGS_SCF_MANAGE_USERS';
export const SETTINGS_MOBILE_MENU = 'SETTINGS_MOBILE_MENU';
export const SETTINGS_NOTIFICATION_PREFERENCES = 'SETTINGS_NOTIFICATION_PREFERENCES';
export const SETTINGS_PROFILE = 'SETTINGS_PROFILE';
export const SETTINGS_RESET_PASSWORD = 'SETTINGS_RESET_PASSWORD';
export const ADMIN = 'ADMIN';
export const ADMIN_OVERVIEW = 'ADMIN_OVERVIEW';
export const ADMIN_SUPPLIERS = 'ADMIN_SUPPLIERS';
export const ADMIN_MANAGE_SUPPLIER = 'ADMIN_MANAGE_SUPPLIER';
export const ADMIN_MANAGE_SUPPLIER_INFORMATION = 'ADMIN_MANAGE_SUPPLIER_INFORMATION';
export const ADMIN_MANAGE_SUPPLIER_IMPLEMENTATION = 'ADMIN_MANAGE_SUPPLIER_IMPLEMENTATION';
export const ADMIN_MANAGE_SUPPLIER_PAYMENT_METHODS = 'ADMIN_MANAGE_SUPPLIER_PAYMENT_METHODS';
export const ADMIN_CREATE_SUPPLIER = 'ADMIN_CREATE_SUPPLIER';
export const ADMIN_BUYERS = 'ADMIN_BUYERS';
export const ADMIN_BUYER = 'ADMIN_BUYER';
export const ADMIN_CREATE_BUYER = 'ADMIN_CREATE_BUYER';
export const ADMIN_MANAGE_BUYER = 'ADMIN_MANAGE_BUYER';
export const ADMIN_MANAGE_BUYER_COMPANY = 'ADMIN_MANAGE_BUYER_COMPANY';
export const ADMIN_MANAGE_BUYER_LOCATION = 'ADMIN_MANAGE_BUYER_LOCATION';
export const ADMIN_MANAGE_BUYER_CONFIGURATION = 'ADMIN_MANAGE_BUYER_CONFIGURATION';
export const ADMIN_MANAGE_BUYER_CONTACT = 'ADMIN_MANAGE_BUYER_CONTACT';
export const ADMIN_REVIEW_BUYER = 'ADMIN_REVIEW_BUYER';
export const ADMIN_PROSPECTS = 'ADMIN_PROSPECTS';
export const ADMIN_INVOICES = 'ADMIN_INVOICES';
export const ADMIN_PURCHASE_REQUESTS = 'ADMIN_PURCHASE_REQUESTS';
export const VIEW_DOCUMENTS = 'VIEW_DOCUMENTS';
export const ADMIN_DOCUMENTS = 'ADMIN_DOCUMENTS';
export const ADMIN_DOCUMENTS_AUDIT = 'ADMIN_DOCUMENTS_AUDIT';
export const ADMIN_MANAGE_PROSPECT = 'ADMIN_MANAGE_PROSPECT';
export const ADMIN_MANAGE_PROSPECT_DETAILS = 'ADMIN_MANAGE_PROSPECT_DETAILS';
export const ADMIN_MANAGE_PROSPECT_MIGRATION = 'ADMIN_MANAGE_PROSPECT_MIGRATION';
export const ADMIN_MANAGE_PROSPECT_ACTIVITY = 'ADMIN_MANAGE_PROSPECT_ACTIVITY';
export const ADMIN_MANAGE_PROSPECT_AUDIT = 'ADMIN_MANAGE_PROSPECT_AUDIT';
export const ADMIN_MANAGE_PROSPECT_USERS = 'ADMIN_MANAGE_PROSPECT_USERS';
export const ADMIN_MANAGE_PROSPECT_INSIGHTS = 'ADMIN_MANAGE_PROSPECT_INSIGHTS';
export const PROSPECT_INSIGHTS = 'PROSPECT_INSIGHTS';

// Leaving this without a type annotation allows the compiler to type it more precisely,
// rather than relying on our { [id: string]: AtlasNode } approximation, which is what
// we'd get if we "correctly" typed this as an `Atlas`.
export const atlas = {
    ROOT: {
        path: UiRoutes.Home,
        title: 'LSQ',
        children: {
            LOGIN: {
                path: UiRoutes.Login,
                title: AppRoutesI18n.Login,
                allowAnonymous: true
            },
            LOGOUT: {
                path: UiRoutes.Logout,
                title: AppRoutesI18n.Logout
            },
            EULA: {
                path: 'eula',
                title: AppRoutesI18n.Eula
            },
            RESET_PASSWORD: {
                path: UiRoutes.ResetPassword,
                title: AppRoutesI18n.ResetPassword,
                allowAnonymous: true
            },
            NOT_FOUND: {
                path: UiRoutes.NotFound,
                title: AppRoutesI18n.NotFound,
                allowAnonymous: true
            },
            HEALTH: {
                path: UiRoutes.Health,
                title: AppRoutesI18n.Health,
                allowAnonymous: true
            },
            HEALTH_ALT: {
                path: 'healthz',
                title: AppRoutesI18n.Health,
                allowAnonymous: true
            },
            SELECT_ACCOUNT: {
                path: UiRoutes.SelectCompany,
                title: AppRoutesI18n.SelectCompany
            },
            BROWSER_NOT_SUPPORTED: {
                path: UiRoutes.NotSupported,
                title: AppRoutesI18n.BrowserNotSupported,
                allowAnonymous: true
            },
            LOCAL: {
                path: UiRoutes.Local,
                environments: [Environment.Development, Environment.Staging],
                children: {
                    LOCAL_BACKEND: {
                        path: UiRoutes.LocalBackend,
                        title: 'Local Backend',
                        environments: [Environment.Development, Environment.Staging],
                        allowAnonymous: true
                    },
                    LOCAL_CLAIMS: {
                        path: UiRoutes.LocalClaims,
                        title: AppRoutesI18n.LocalClaims,
                        environments: [Environment.Development, Environment.Staging]
                    },
                    LOCAL_USER_STATE: {
                        path: 'user-state',
                        title: AppRoutesI18n.LocalUserState,
                        environments: [Environment.Development, Environment.Staging]
                    }
                }
            },
            ADMIN: {
                path: 'admin',
                claims: [DashboardClaim.SystemManagement],
                children: {
                    ADMIN_OVERVIEW: {
                        path: UiRoutes.Home,
                        title: 'Client Management',
                        claims: [DashboardClaim.SystemManagement]
                    },
                    ADMIN_USER_MANAGEMENT: {
                        path: 'user-management',
                        title: 'Admin User Management',
                        claims: [DashboardClaim.SystemManagement],
                        featureFlags: [FeatureFlags.AdminUserManagement]
                    },
                    ADMIN_DOCUMENTS: {
                        path: `documents/${RouteParams.CompanyKey}`,
                        title: 'Admin Document Center',
                        claims: [DashboardClaim.AdminViewDocument],
                        featureFlags: [FeatureFlags.DocumentCenter],
                        children: {
                            ADMIN_DOCUMENTS_AUDIT: {
                                path: 'audit',
                                title: 'Audit'
                            }
                        }
                    },
                    ADMIN_SUPPLIERS: {
                        path: 'suppliers',
                        title: 'Suppliers',
                        claims: [DashboardClaim.AdminViewSupplier]
                    },
                    ADMIN_MANAGE_SUPPLIER: {
                        path: `relationship/${RouteParams.RelationshipKey}`,
                        title: 'Manage Supplier',
                        claims: [DashboardClaim.AdminViewSupplier],
                        children: {
                            ADMIN_MANAGE_SUPPLIER_INFORMATION: {
                                path: 'information',
                                title: 'Manage Supplier Information'
                            },
                            ADMIN_MANAGE_SUPPLIER_IMPLEMENTATION: {
                                path: 'implementation',
                                title: 'Manage Supplier Implementation'
                            },
                            ADMIN_MANAGE_SUPPLIER_PAYMENT_METHODS: {
                                path: 'payment-methods',
                                title: 'Manage Supplier Payment Methods'
                            }
                        }
                    },
                    ADMIN_CREATE_SUPPLIER: {
                        path: `suppliers/create`,
                        title: 'Create Supplier',
                        claims: [DashboardClaim.AdminViewSupplier]
                    },
                    ADMIN_BUYERS: {
                        path: 'buyers',
                        title: 'Buyers',
                        claims: [DashboardClaim.AdminViewBuyer]
                    },
                    ADMIN_BUYER: {
                        path: 'buyer',
                        children: {
                            ADMIN_CREATE_BUYER: {
                                path: `create`,
                                title: 'Add Buyer',
                                claims: [DashboardClaim.AdminEditBuyer],
                                featureFlags: [FeatureFlags.AdminCreateBuyer]
                            },
                            ADMIN_MANAGE_BUYER: {
                                path: `${RouteParams.BuyerKey}`,
                                title: 'Manage Buyer',
                                claims: [DashboardClaim.AdminViewBuyer],
                                children: {
                                    ADMIN_MANAGE_BUYER_COMPANY: {
                                        path: 'company-information',
                                        title: 'Manage Buyer Company'
                                    },
                                    ADMIN_MANAGE_BUYER_LOCATION: {
                                        path: 'company-location',
                                        title: 'Manage Buyer Company Location'
                                    },
                                    ADMIN_MANAGE_BUYER_CONFIGURATION: {
                                        path: 'configuration',
                                        title: 'Manage Buyer Configuration'
                                    },
                                    ADMIN_MANAGE_BUYER_CONTACT: {
                                        path: 'contact',
                                        title: 'Manage Buyer Contact'
                                    },
                                    ADMIN_REVIEW_BUYER: {
                                        path: 'review',
                                        title: 'Review Buyer'
                                    }
                                }
                            }
                        }
                    },
                    ADMIN_PROSPECTS: {
                        path: 'prospects',
                        title: 'Prospects',
                        claims: [DashboardClaim.AdminViewProspect]
                    },
                    ADMIN_INVOICES: {
                        path: 'invoices',
                        title: 'Invoices',
                        claims: [DashboardClaim.AdminViewInvoice]
                    },
                    ADMIN_PURCHASE_REQUESTS: {
                        path: 'purchase-requests',
                        title: 'Purchase Requests',
                        claims: [DashboardClaim.AdminViewInvoice],
                        featureFlags: [FeatureFlags.PurchaseRequestsUI]
                    },
                    ADMIN_MANAGE_PROSPECT: {
                        path: `prospect/${RouteParams.ProspectId}`,
                        title: 'Manage Prospect',
                        claims: [DashboardClaim.AdminEditProspect],
                        children: {
                            ADMIN_MANAGE_PROSPECT_DETAILS: {
                                path: 'details',
                                title: 'Manage Prospect Company'
                            },
                            ADMIN_MANAGE_PROSPECT_MIGRATION: {
                                path: 'migration',
                                title: 'Manage Migration'
                            },
                            ADMIN_MANAGE_PROSPECT_ACTIVITY: {
                                path: 'activity',
                                title: 'Manage activity'
                            },
                            ADMIN_MANAGE_PROSPECT_AUDIT: {
                                path: 'audit',
                                title: 'Audit'
                            },
                            ADMIN_MANAGE_PROSPECT_USERS: {
                                path: 'users',
                                title: 'Users'
                            },
                            ADMIN_MANAGE_PROSPECT_INSIGHTS: {
                                path: 'insights',
                                title: 'Insights',
                                claims: [DashboardClaim.AdminViewProspectInsights],
                                children: {
                                    PROSPECT_INSIGHTS_TERMS_BREAKDOWN: {
                                        path: 'terms-breakdown',
                                        title: 'Net Terms Breakdown',
                                        featureFlags: [],
                                        claims: []
                                    },
                                    PROSPECT_INSIGHTS_DISCOUNTED_TERMS: {
                                        path: 'discounted-terms',
                                        title: 'Discounted Terms',
                                        featureFlags: [],
                                        claims: []
                                    },
                                    PROSPECT_INSIGHTS_WCL_BC: {
                                        path: 'wcl-bc',
                                        title: 'Working Capital Lift',
                                        featureFlags: [],
                                        claims: []
                                    },
                                    PROSPECT_INSIGHTS_DATA_SCOPE: {
                                        path: 'data-scope',
                                        title: 'Data Scope',
                                        featureFlags: [],
                                        claims: []
                                    },
                                    PROSPECT_INSIGHTS_DPO_BREAKDOWN: {
                                        path: 'dpo-breakdown',
                                        title: 'DPO Breakdown',
                                        featureFlags: [],
                                        claims: []
                                    },
                                    PROSPECT_INSIGHTS_TOP_EXCLUDED_SUPP: {
                                        path: 'top-excluded-suppliers',
                                        title: 'Top 25 Excluded Suppliers',
                                        featureFlags: [],
                                        claims: []
                                    },
                                    PROSPECT_INSIGHTS_TOP_ADDRESSABLE_SUPP: {
                                        path: 'top-addresable-suppliers',
                                        title: 'Top 25 Addressable Suppliers',
                                        featureFlags: [],
                                        claims: []
                                    },
                                    PROSPECT_INSIGHTS_PAYMENT_TYPE_BREAKDOWN: {
                                        path: 'payment-type-breakdown',
                                        title: 'Payment Type Breakdown',
                                        featureFlags: [],
                                        claims: []
                                    }
                                }
                            }
                        }
                    }
                }
            },
            ENROLLMENT: {
                path: 'enrollment',
                title: 'Enroll in Supply Chain Finance',
                allowAnonymous: true
            },
            AR_APPLICATION: {
                path: 'portal',
                title: 'Documents',
                allowAnonymous: true,
                children: {
                    AR_APPLICATION_APPLY: {
                        path: 'documents',
                        title: 'Documents',
                        claims: []
                    },
                    PROSPECT_INSIGHTS: {
                        path: 'insights',
                        title: 'Insights',
                        claims: [DashboardClaim.ProspectInsights],
                        children: {
                            PROSPECT_INSIGHTS_TERMS_BREAKDOWN: {
                                path: 'terms-breakdown',
                                title: 'Net Terms Breakdown',
                                featureFlags: [],
                                claims: []
                            },
                            PROSPECT_INSIGHTS_DISCOUNTED_TERMS: {
                                path: 'discounted-terms',
                                title: 'Discounted Terms',
                                featureFlags: [],
                                claims: []
                            },
                            PROSPECT_INSIGHTS_WCL_BC: {
                                path: 'wcl-bc',
                                title: 'Working Capital Lift',
                                featureFlags: [],
                                claims: []
                            },
                            PROSPECT_INSIGHTS_DATA_SCOPE: {
                                path: 'data-scope',
                                title: 'Data Scope',
                                featureFlags: [],
                                claims: []
                            },
                            PROSPECT_INSIGHTS_DPO_BREAKDOWN: {
                                path: 'dpo-breakdown',
                                title: 'DPO Breakdown',
                                featureFlags: [],
                                claims: []
                            },
                            PROSPECT_INSIGHTS_TOP_EXCLUDED_SUPP: {
                                path: 'top-excluded-suppliers',
                                title: 'Top 25 Excluded Suppliers',
                                featureFlags: [],
                                claims: []
                            },
                            PROSPECT_INSIGHTS_TOP_ADDRESSABLE_SUPP: {
                                path: 'top-addresable-suppliers',
                                title: 'Top 25 Addressable Suppliers',
                                featureFlags: [],
                                claims: []
                            },
                            PROSPECT_INSIGHTS_PAYMENT_TYPE_BREAKDOWN: {
                                path: 'payment-type-breakdown',
                                title: 'Payment Type Breakdown',
                                featureFlags: [],
                                claims: []
                            }
                        }
                    }
                }
            },
            VIEW_DOCUMENTS: {
                path: 'documents',
                title: 'Documents',
                claims: [DashboardClaim.ViewDocuments]
            },
            MOBILE_UPLOAD_TOKEN: {
                path: 'mut',
                title: AppRoutesI18n.MobileUploadToken,
                allowAnonymous: true
            },
            FACTORING: {
                path: '',
                title: AppRoutesI18n.Dashboard,
                claims: [DashboardClaim.FactoringDashboard],
                children: {
                    FACTORING_HOME: {
                        path: '',
                        title: AppRoutesI18n.Dashboard
                    },
                    MOBILE_UPLOADS: {
                        path: 'mobile-uploads',
                        title: AppRoutesI18n.MobileUploads,
                        claims: [DashboardClaim.MobileInvoiceUpload]
                    },
                    REQUEST_FUNDS: {
                        path: 'request-funds',
                        title: AppRoutesI18n.RequestFunds,
                        claims: [DashboardClaim.ViewRequestFunds]
                    },
                    INVOICE_UPLOAD_HISTORY: {
                        path: 'invoice-upload-history',
                        title: AppRoutesI18n.InvoiceUploadHistory,
                        claims: [DashboardClaim.ViewInvoiceUploads]
                    },
                    INCREASE_CREDIT_LIMIT: {
                        path: 'increase-credit-limit',
                        title: AppRoutesI18n.IncreaseCreditLimit,
                        claims: [DashboardClaim.ViewCustomers]
                    },

                    CONTACT_US: {
                        path: 'contact-us',
                        title: AppRoutesI18n.ContactUs,
                        claims: [DashboardClaim.FactoringDashboard]
                    },

                    REPORTS: {
                        path: 'reports',
                        title: ReportsRoutesI18n.Reports,
                        claims: [DashboardClaim.ViewReports, DashboardClaim.ViewCustomers],
                        children: {
                            REPORTS_PURCHASES: {
                                path: 'purchases',
                                title: ReportsRoutesI18n.Purchases,
                                claims: [DashboardClaim.ViewReports]
                            },
                            REPORTS_ACCOUNT_OVERVIEW: {
                                path: 'account-overview',
                                title: ReportsRoutesI18n.AccountOverviewByDate,
                                claims: [DashboardClaim.ViewReports]
                            },
                            REPORTS_AGING: {
                                path: 'aging',
                                title: ReportsRoutesI18n.Aging,
                                claims: [DashboardClaim.ViewReports]
                            },
                            REPORTS_COLLECTIONS: {
                                path: 'collections',
                                title: ReportsRoutesI18n.Collections,
                                claims: [DashboardClaim.ViewReports]
                            },
                            REPORTS_FUNDINGS: {
                                path: 'fundings',
                                title: ReportsRoutesI18n.Fundings,
                                claims: [DashboardClaim.ViewReports]
                            },
                            REPORTS_AVAILABLE_FUNDS_SUMMARY: {
                                path: 'available-funds-summary',
                                title: ReportsRoutesI18n.AvailableFundsSummary,
                                claims: [DashboardClaim.ViewReports]
                            },
                            REPORTS_INELIGIBLES: {
                                path: 'ineligibles',
                                title: ReportsRoutesI18n.Ineligibles,
                                claims: [DashboardClaim.ViewReports]
                            },
                            REPORTS_CREDIT_REQUEST_HISTORY: {
                                path: 'credit-request-history',
                                title: ReportsRoutesI18n.CreditRequestHistory,
                                claims: [DashboardClaim.ViewCustomers, DashboardClaim.ViewReports]
                            },
                            REPORTS_INVOICE_NUMBER_RESULTS: {
                                path: 'invoice-number-results',
                                title: ReportsRoutesI18n.SearchResults,
                                claims: [DashboardClaim.ViewReports]
                            },
                            REPORTS_CHECK_NUMBER_RESULTS: {
                                path: 'check-number-results',
                                title: ReportsRoutesI18n.SearchResults,
                                claims: [DashboardClaim.ViewReports]
                            }
                        }
                    },
                    INVOICES: {
                        path: 'invoices',
                        children: {
                            INVOICES_UPLOAD: {
                                path: 'upload',
                                title: InvoiceRoutesI18n.UploadInvoicesNavigationLabel,
                                claims: [DashboardClaim.ViewInvoiceUploads]
                            },
                            INVOICES_INVOICE: {
                                path: RouteParams.InvoiceKey,
                                title: InvoiceRoutesI18n.InvoiceDetailTitle,
                                claims: [DashboardClaim.ViewReports]
                            }
                        }
                    },
                    CUSTOMERS: {
                        path: 'customers',
                        title: CustomersRoutesI18n.Customers,
                        claims: [DashboardClaim.ViewCustomers],
                        children: {
                            CUSTOMERS_REQUEST_CREDIT: {
                                path: 'request-new-customer-credit',
                                title: CustomersRoutesI18n.RequestNewCustomerCredit,
                                claims: [DashboardClaim.ViewCustomers]
                            },
                            CUSTOMER: {
                                path: RouteParams.DebtorKey,
                                children: {
                                    CUSTOMER_OVERVIEW: {
                                        path: 'overview',
                                        title: CustomersRoutesI18n.Overview,
                                        claims: [DashboardClaim.ViewCustomers]
                                    },
                                    CUSTOMER_REPORTS: {
                                        path: 'report',
                                        title: ReportsRoutesI18n.Reports,
                                        children: {
                                            CUSTOMER_AGING: {
                                                path: 'aging',
                                                title: CustomersRoutesI18n.Aging,
                                                claims: [DashboardClaim.ViewReports]
                                            },
                                            CUSTOMER_COLLECTIONS: {
                                                path: 'collections',
                                                title: CustomersRoutesI18n.Collections,
                                                claims: [DashboardClaim.ViewReports]
                                            },
                                            CUSTOMER_PURCHASES: {
                                                path: 'purchases',
                                                title: CustomersRoutesI18n.Purchases,
                                                claims: [DashboardClaim.ViewReports]
                                            },
                                            CUSTOMER_INELIGIBLES: {
                                                path: 'ineligibles',
                                                title: CustomersRoutesI18n.Ineligibles,
                                                claims: [DashboardClaim.ViewReports]
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    INSIGHTS: {
                        path: 'insights',
                        title: InsightsRoutesI18n.Insights,
                        claims: [DashboardClaim.ViewReports],
                        featureFlags: [FeatureFlags.ArInsights],
                        children: {
                            INSIGHTS_CUSTOMERS_BY_EXPOSURE: {
                                path: 'customers-by-exposure',
                                title: InsightsRoutesI18n.CustomersByExposure,
                                claims: [DashboardClaim.ViewReports],
                                featureFlags: [FeatureFlags.ArInsights]
                            }
                        }
                    }
                }
            },
            SUPPLY_CHAIN_DIRECT: {
                path: 'supply-chain',
                title: 'Supply Chain Financing',
                children: {
                    SUPPLY_CHAIN_DIRECT_SELLER: {
                        path: 'supplier',
                        title: 'Supplier',
                        claims: [DashboardClaim.FinancingVendorPortal],
                        children: {
                            SUPPLY_CHAIN_DIRECT_SELLER_INVOICES: {
                                path: 'invoices',
                                title: 'Invoices',
                                claims: [DashboardClaim.FinancingVendorPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_SELLER_PAYMENTS: {
                                path: 'payments',
                                title: 'Payments',
                                claims: [DashboardClaim.FinancingVendorPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_SELLER_CONTACT_US: {
                                path: 'contact-us',
                                title: 'Contact Us',
                                claims: [DashboardClaim.FinancingVendorPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_SELLER_BUYERS: {
                                path: 'buyers',
                                title: 'Buyers',
                                claims: [DashboardClaim.FinancingVendorPortal],
                                featureFlags: [FeatureFlags.SupplierBuyersPage]
                            },
                            SUPPLY_CHAIN_DIRECT_SELLER_REQUEST_EARLY_PAYMENT: {
                                path: 'request-early-payment',
                                title: 'Request Early Payment',
                                claims: [DashboardClaim.FinancingVendorPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_DASHBOARD: {
                                path: 'dashboard',
                                title: 'Dashboard',
                                claims: [DashboardClaim.FinancingVendorPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_SELLER_PAYMENT: {
                                path: 'payment',
                                children: {
                                    SUPPLY_CHAIN_DIRECT_SELLER_PAYMENT_SUMMARY: {
                                        path: RouteParams.FundingBatchKey,
                                        title: 'Payment Summary'
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_SELLER_BUYER_PAYMENT: {
                                path: 'buyer-payment',
                                children: {
                                    SUPPLY_CHAIN_DIRECT_SELLER_BUYER_PAYMENT_SUMMARY: {
                                        path: RouteParams.FundingBatchKey,
                                        title: 'Payment Summary'
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_SELLER_INVOICE: {
                                path: 'invoice',
                                children: {
                                    INVOICE_DETAIL: {
                                        path: RouteParams.InvoiceKey,
                                        title: 'Invoice Detail',
                                        claims: [DashboardClaim.FinancingVendorPortal]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_SELLER_GROUPED_INVOICE: {
                                path: 'grouped-invoice',
                                children: {
                                    GROUPED_INVOICE_DETAIL: {
                                        path: RouteParams.GroupedInvoiceKey,
                                        title: 'Invoice Detail',
                                        claims: [DashboardClaim.FinancingVendorPortal]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_SELLER_REPORTS: {
                                path: 'reports',
                                title: 'Reports',
                                claims: [DashboardClaim.FinancingVendorPortal],
                                featureFlags: [FeatureFlags.SellerReportCenter],
                                children: {
                                    SUPPLY_CHAIN_DIRECT_SELLER_CREATE_NEW_REPORT: {
                                        path: `create-new-report`,
                                        title: 'Create New Report'
                                    },
                                    SUPPLY_CHAIN_DIRECT_SELLER_EDIT_REPORT: {
                                        path: `edit-report`,
                                        children: {
                                            SUPPLY_CHAIN_DIRECT_SELLER_EDIT_REPORT_ID: {
                                                path: RouteParams.ReportId,
                                                title: 'Edit Report'
                                            }
                                        }
                                    },
                                    SUPPLY_CHAIN_DIRECT_SELLER_REPORT_COMPANY_ROLE: {
                                        path: RouteParams.CompanyRoleId,
                                        children: {
                                            SUPPLY_CHAIN_DIRECT_SELLER_REPORT_PREVIEW: {
                                                path: 'preview',
                                                title: 'Report Preview'
                                            }
                                        }
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_SELLER_PARENT_GROUPED_INVOICE: {
                                path: 'grouped-invoice-parent',
                                children: {
                                    SUPPLY_CHAIN_DIRECT_SELLER_PARENT_GROUPED_INVOICE_DETAIL: {
                                        path: RouteParams.InvoiceKey,
                                        title: 'Invoice Detail',
                                        claims: [DashboardClaim.FinancingVendorPortal],
                                        featureFlags: [FeatureFlags.PendingCreditMemosDetails]
                                    }
                                }
                            }
                        }
                    },
                    SUPPLY_CHAIN_DIRECT_ACCOUNT: {
                        path: 'buyer-account',
                        title: 'Buyer Account',
                        claims: [
                            DashboardClaim.FinancingAccountPortal,
                            DashboardClaim.FinancingBuyerPortal
                        ],
                        children: {
                            SUPPLY_CHAIN_DIRECT_ACCOUNT_OVERVIEW: {
                                path: 'overview',
                                title: 'Overview',
                                claims: [DashboardClaim.FinancingAccountPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICES: {
                                path: 'invoices',
                                title: 'Invoices',
                                claims: [DashboardClaim.FinancingAccountPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_ACCOUNT_INVOICE: {
                                path: 'invoice',
                                children: {
                                    BUYER_ACCOUNT_INVOICE_DETAIL: {
                                        path: RouteParams.InvoiceKey,
                                        title: 'Invoice Detail',
                                        claims: [
                                            DashboardClaim.FinancingAccountPortal,
                                            DashboardClaim.FinancingBuyerPortal
                                        ]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIERS: {
                                path: 'suppliers',
                                title: 'Suppliers',
                                claims: [DashboardClaim.FinancingAccountPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_ACCOUNT_PAYMENTS: {
                                path: 'payments',
                                title: 'Payments',
                                claims: [DashboardClaim.FinancingAccountPortal],
                                FeatureFlags: [FeatureFlags.BuyerAccountPaymentsPage]
                            },
                            SUPPLY_CHAIN_DIRECT_ACCOUNT_SUPPLIER_DETAILS: {
                                path: 'supplier',
                                children: {
                                    ACCOUNT_SUPPLIER_DETAILS: {
                                        path: RouteParams.SellerKey,
                                        title: 'Supplier Details',
                                        claims: [DashboardClaim.FinancingAccountPortal],
                                        featureFlags: [FeatureFlags.SupplierDetailsForBuyers]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_DETAILS: {
                                path: 'early-payment',
                                children: {
                                    ACCOUNT_EARLY_PAYMENT_DETAILS: {
                                        path: RouteParams.EarlyPaymentKey,
                                        title: 'Early Payment Detail',
                                        claims: [DashboardClaim.FinancingAccountPortal]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS: {
                                path: 'early-payment-remittance',
                                children: {
                                    ACCOUNT_EARLY_PAYMENT_REMITTANCE_DETAILS: {
                                        path: RouteParams.EarlyPaymentKey,
                                        title: 'Early Payment Detail',
                                        claims: [DashboardClaim.FinancingAccountPortal]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS: {
                                path: 'invoice-terms-payment',
                                children: {
                                    ACCOUNT_INVOICE_TERMS_PAYMENT_DETAILS: {
                                        path: RouteParams.EarlyPaymentKey,
                                        title: 'Invoice Terms Payment Detail',
                                        claims: [DashboardClaim.FinancingAccountPortal]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE: {
                                path: 'grouped-invoice-parent',
                                children: {
                                    SUPPLY_CHAIN_DIRECT_ACCOUNT_PARENT_GROUPED_INVOICE_DETAIL: {
                                        path: RouteParams.InvoiceKey,
                                        title: 'Invoice Detail',
                                        claims: [DashboardClaim.FinancingAccountPortal],
                                        featureFlags: [FeatureFlags.PendingCreditMemosDetails]
                                    }
                                }
                            }
                        }
                    },
                    SUPPLY_CHAIN_DIRECT_BUYER: {
                        path: 'buyer',
                        title: 'Buyer',
                        claims: [DashboardClaim.FinancingBuyerPortal],
                        children: {
                            SUPPLY_CHAIN_DIRECT_BUYER_OVERVIEW: {
                                path: 'overview',
                                title: 'Overview',
                                claims: [DashboardClaim.FinancingBuyerPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIERS: {
                                path: 'suppliers',
                                title: 'Suppliers',
                                claims: [DashboardClaim.FinancingBuyerPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIER_DETAILS: {
                                path: 'supplier',
                                children: {
                                    BUYER_SUPPLIER_DETAILS: {
                                        path: RouteParams.SellerKey,
                                        title: 'Supplier Details',
                                        claims: [DashboardClaim.FinancingBuyerPortal],
                                        featureFlags: [FeatureFlags.SupplierDetailsForBuyers]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE: {
                                path: 'grouped-invoice-parent',
                                children: {
                                    SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE_DETAIL: {
                                        path: RouteParams.InvoiceKey,
                                        title: 'Invoice Detail',
                                        claims: [DashboardClaim.FinancingBuyerPortal],
                                        featureFlags: [FeatureFlags.PendingCreditMemosDetails]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_PAY_LATER: {
                                path: 'pay-later',
                                title: 'Request FlexTerm',
                                claims: [DashboardClaim.FinancingBuyerPortal],
                                featureFlags: [FeatureFlags.PayLater]
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_INVOICES: {
                                path: 'invoices',
                                title: 'Invoices',
                                claims: [DashboardClaim.FinancingBuyerPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS: {
                                path: 'insights',
                                title: 'Insights',
                                claims: [DashboardClaim.FinancingBuyerPortal],
                                featureFlags: [FeatureFlags.BuyerExperienceAnalyticsInsights],
                                children: {
                                    SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SPEND_VOLUME: {
                                        path: 'spend-volume',
                                        title: 'Spend Volume',
                                        claims: [DashboardClaim.FinancingBuyerPortal],
                                        featureFlags: [
                                            FeatureFlags.BuyerExperienceAnalyticsInsights
                                        ]
                                    },
                                    SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_WORKING_CAPITAL_LIFT: {
                                        path: 'working-capital-lift',
                                        title: 'Working Capital Lift',
                                        claims: [DashboardClaim.FinancingBuyerPortal],
                                        featureFlags: [
                                            FeatureFlags.BuyerExperienceAnalyticsInsights
                                        ]
                                    },
                                    SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_EARLY_PAY_ADOPTION: {
                                        path: 'early-pay-adoption',
                                        title: 'Early Pay Adoption',
                                        claims: [DashboardClaim.FinancingBuyerPortal],
                                        featureFlags: [
                                            FeatureFlags.BuyerExperienceAnalyticsInsights
                                        ]
                                    },
                                    SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SUPPLIER_ENROLLMENT: {
                                        path: 'supplier-enrollment',
                                        title: 'Supplier Enrollment',
                                        claims: [DashboardClaim.FinancingBuyerPortal],
                                        featureFlags: [
                                            FeatureFlags.BuyerExperienceAnalyticsInsights
                                        ]
                                    },
                                    SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_AGING_FORECAST: {
                                        path: 'aging-forecast',
                                        title: 'Aging Forecast',
                                        claims: [DashboardClaim.FinancingBuyerPortal],
                                        featureFlags: [
                                            FeatureFlags.BuyerExperienceAnalyticsInsights
                                        ]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_PAYMENTS: {
                                path: 'payments',
                                title: 'Payments',
                                claims: [DashboardClaim.FinancingBuyerPortal]
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_DETAILS: {
                                path: 'early-payment',
                                children: {
                                    EARLY_PAYMENT_DETAILS: {
                                        path: RouteParams.EarlyPaymentKey,
                                        title: 'Early Payment Detail',
                                        claims: [DashboardClaim.FinancingBuyerPortal]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_REMITTANCE_DETAILS: {
                                path: 'early-payment-remittance',
                                children: {
                                    EARLY_PAYMENT_REMITTANCE_DETAILS: {
                                        path: RouteParams.EarlyPaymentKey,
                                        title: 'Early Payment Detail',
                                        claims: [DashboardClaim.FinancingBuyerPortal]
                                    }
                                }
                            },
                            SUPPLY_CHAIN_DIRECT_BUYER_INVOICE_TERMS_PAYMENT_DETAILS: {
                                path: 'invoice-terms-payment',
                                children: {
                                    INVOICE_TERMS_PAYMENT_DETAILS: {
                                        path: RouteParams.EarlyPaymentKey,
                                        title: 'Invoice Terms Payment Detail',
                                        claims: [DashboardClaim.FinancingBuyerPortal]
                                    }
                                }
                            }
                        }
                    }
                }
            },
            SUPPLY_CHAIN_PLATFORM: {
                path: `platform/${RouteParams.PlatformId}`,
                title: 'Supply Chain Financing',
                allowAnonymous: true,
                children: {
                    SUPPLY_CHAIN_PLATFORM_LANDING: {
                        path: '',
                        title: 'Supply Chain Financing'
                    },
                    SUPPLY_CHAIN_PLATFORM_SESSION_TIMEOUT: {
                        path: 'timeout',
                        title: 'Timeout'
                    },
                    SUPPLY_CHAIN_PLATFORM_NOT_AUTHORIZED: {
                        path: 'not-authorized',
                        title: 'Not Authorized'
                    },
                    SUPPLY_CHAIN_PLATFORM_ENROLLMENT_OVERVIEW: {
                        path: 'overview',
                        title: 'Enroll in Supply Chain Financing | Overview'
                    },
                    SUPPLY_CHAIN_PLATFORM_ENROLLMENT_ENROLL: {
                        path: 'enroll',
                        title: 'Enroll in Supply Chain Financing | Enroll'
                    },
                    SUPPLY_CHAIN_PLATFORM_ENROLLMENT_NEXT_STEPS: {
                        path: 'next-steps',
                        title: 'Enroll in Supply Chain Financing | Next Steps'
                    },
                    SUPPLY_CHAIN_PLATFORM_ENROLLMENT_NOT_INTERESTED: {
                        path: 'not-interested',
                        title: 'Enroll in Supply Chain Financing'
                    },
                    SUPPLY_CHAIN_PLATFORM_SETTINGS: {
                        path: 'settings',
                        title: 'Supply Chain Financing',
                        children: {
                            SETTINGS_SCF_PLATFORM_MOBILE_MENU: {
                                path: 'menu',
                                title: SettingsRoutesI18n.Settings,
                                claims: [DashboardClaim.FinancingPlatformEnrollment]
                            },
                            SETTINGS_SCF_PLATFORM_PAYMENT_METHODS: {
                                path: 'payment-methods',
                                title: SettingsRoutesI18n.PaymentMethods,
                                claims: [DashboardClaim.FinancingPlatformEnrollment],
                                navigationGroups: [DashboardNavigationGroups.ScfPlatformSettings]
                            },
                            SETTINGS_SCF_PLATFORM_FAQ: {
                                path: 'faq',
                                title: SettingsRoutesI18n.FAQ,
                                claims: [DashboardClaim.FinancingPlatformEnrollment],
                                navigationGroups: [DashboardNavigationGroups.ScfPlatformSettings]
                            },
                            SETTINGS_SCF_PLATFORM_NOTIFICATION_PREFERENCES: {
                                path: 'notification-preferences',
                                title: SettingsRoutesI18n.NotificationPreferences,
                                navigationGroups: [DashboardNavigationGroups.ScfPlatformSettings],
                                claims: [DashboardClaim.FinancingPlatformEnrollment]
                            }
                        }
                    }
                }
            },
            SETTINGS: {
                path: 'settings',
                title: SettingsRoutesI18n.Settings,
                claims: [
                    DashboardClaim.ViewProfile,
                    DashboardClaim.ViewUsers,
                    DashboardClaim.ViewBankAccounts,
                    DashboardClaim.FinancingViewBankAccounts,
                    DashboardClaim.FinancingViewUsers
                ],
                children: {
                    SETTINGS_MOBILE_MENU: {
                        path: 'menu',
                        title: SettingsRoutesI18n.Settings,
                        claims: [DashboardClaim.ViewProfile]
                    },
                    SETTINGS_PROFILE: {
                        path: 'profile',
                        title: SettingsRoutesI18n.Profile,
                        navigationGroups: [
                            DashboardNavigationGroups.FactoringSettings,
                            DashboardNavigationGroups.ScfDirectSettings,
                            DashboardNavigationGroups.ScfBuyerPortalSettings
                        ],
                        claims: [DashboardClaim.ViewProfile]
                    },
                    SETTINGS_NOTIFICATION_PREFERENCES: {
                        path: 'notification-preferences',
                        title: SettingsRoutesI18n.NotificationPreferences,
                        navigationGroups: [
                            DashboardNavigationGroups.FactoringSettings,
                            DashboardNavigationGroups.ScfDirectSettings
                        ],
                        claims: [
                            DashboardClaim.FactoringDashboard,
                            DashboardClaim.FinancingVendorPortal,
                            DashboardClaim.FinancingBuyerPortal
                        ]
                    },
                    SETTINGS_RESET_PASSWORD: {
                        path: 'reset-password',
                        title: SettingsRoutesI18n.ResetPassword,
                        navigationGroups: [
                            DashboardNavigationGroups.FactoringSettings,
                            DashboardNavigationGroups.ScfDirectSettings
                        ],
                        claims: [
                            DashboardClaim.FactoringDashboard,
                            DashboardClaim.FinancingVendorPortal,
                            DashboardClaim.FinancingBuyerPortal,
                            DashboardClaim.FinancingAccountPortal
                        ]
                    },
                    SETTINGS_MANAGE_USERS: {
                        path: 'manage-users',
                        title: SettingsRoutesI18n.ManageUsers,
                        claims: [DashboardClaim.ViewUsers],
                        navigationGroups: [DashboardNavigationGroups.FactoringSettings]
                    },
                    SETTINGS_SCF_MANAGE_USERS: {
                        path: 'supply-chain-manage-users',
                        title: SettingsRoutesI18n.ScfManageUsers,
                        claims: [
                            DashboardClaim.FinancingViewUsers,
                            DashboardClaim.FinancingBuyerPortalViewUsers,
                            DashboardClaim.FinancingAccountPortalViewUsers
                        ],
                        navigationGroups: [
                            DashboardNavigationGroups.ScfDirectSettings,
                            DashboardNavigationGroups.ScfBuyerPortalSettings
                        ]
                    },
                    SETTINGS_SCF_DIRECT_BANK_ACCOUNTS: {
                        path: 'supply-chain-bank-accounts',
                        title: SettingsRoutesI18n.ScfBankAccounts,
                        claims: [DashboardClaim.FinancingViewBankAccounts],
                        navigationGroups: [DashboardNavigationGroups.ScfDirectSettings]
                    }
                }
            }
        }
    }
};

export const rootNode = atlas.ROOT;
export const rootAtlas = rootNode.children;
export const factoringNode = rootAtlas.FACTORING;
export const factoringAtlas = factoringNode.children;
export const reportsNode = factoringAtlas.REPORTS;
export const reportsAtlas = reportsNode.children;
export const invoicesNode = factoringAtlas.INVOICES;
export const invoicesAtlas = invoicesNode.children;
export const customersNode = factoringAtlas.CUSTOMERS;
export const customersAtlas = customersNode.children;
export const customerNode = customersAtlas.CUSTOMER;
export const customerAtlas = customerNode.children;
export const customerReportsNode = customerAtlas.CUSTOMER_REPORTS;
export const customerReportsAtlas = customerReportsNode.children;
export const settingsNode = rootAtlas.SETTINGS;
export const settingsAtlas = settingsNode.children;
export const enrollmentNode = rootAtlas.ENROLLMENT;
export const arApplicationNode = rootAtlas.AR_APPLICATION;
export const insightsNode = factoringAtlas.INSIGHTS;
export const insightsAtlas = insightsNode.children;
export const localNode = rootAtlas.LOCAL;
export const localAtlas = localNode.children;
export const supplyChainDirectNode = rootAtlas.SUPPLY_CHAIN_DIRECT;
export const supplyChainDirectAtlas = supplyChainDirectNode.children;
export const supplyChainDirectSellerNode = supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_SELLER;
export const supplyChainDirectSellerAtlas = supplyChainDirectSellerNode.children;
export const supplyChainDirectBuyerNode = supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_BUYER;
export const supplyChainDirectBuyerAtlas = supplyChainDirectBuyerNode.children;
export const supplyChainDirectAccountNode = supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT;
export const supplyChainDirectAccountAtlas = supplyChainDirectAccountNode.children;
export const supplyChainDirectBuyerInsightsNode =
    supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS;
export const supplyChainDirectBuyerInsightsAtlas = supplyChainDirectBuyerInsightsNode.children;
export const supplyChainPlatformNode = rootAtlas.SUPPLY_CHAIN_PLATFORM;
export const supplyChainPlatformAtlas = supplyChainPlatformNode.children;
export const supplyChainPlatformSettingsAtlas =
    supplyChainPlatformNode.children.SUPPLY_CHAIN_PLATFORM_SETTINGS.children;
export const adminNode = rootAtlas.ADMIN;
export const adminAtlas = adminNode.children;
export const documentsNode = rootAtlas.VIEW_DOCUMENTS;
export const arApplicationAtlas = arApplicationNode.children;
export const arAdminAtlas = adminNode.children.ADMIN_MANAGE_PROSPECT.children;
